import { Column, Row, Tooltip } from "@bridgesplit/ui";
import { Divider } from "@mui/material";
import { useActiveWallet, usePrincipalBorrowedWithLeverage } from "@bridgesplit/abf-react";

import { BaseApy } from "./BaseApy";
import { ExternalRewardsDisplay, RateDisplay, TooltipContent } from "./common";
import { RewardsDailyPoints, RewardsDailyPointsBreakdown } from "./daily-rewards";
import { POINT_BASIS, RewardsLoopsApyProps } from "./types";
import { RewardsExternalPointsRewards } from "./external-point-rewards/RewardsExternalPointsReward";
import { RewardsMaxLeverage } from "./loops/RewardsMaxLeverage";

export function RewardsLoopsApy(props: RewardsLoopsApyProps) {
    return (
        <Tooltip noPadding title={<RewardsLoopsTooltip {...props} />} reverseColors>
            <Row spacing={1}>
                <ExternalRewardsDisplay {...props} />
                <RateDisplay apy={props.apy} variant="body1" color="body" isFeatured={props.isFeatured} />
            </Row>
        </Tooltip>
    );
}

function RewardsLoopsTooltip(props: RewardsLoopsApyProps) {
    const { activeWallet } = useActiveWallet();

    const { principalBorrowedWithLeverageUsd } = usePrincipalBorrowedWithLeverage({
        loopExpanded: props.loopExpanded,
        loopLeverage: props.maxLeverage,
        totalAmount: POINT_BASIS / (props.loopExpanded?.inputTokenOracle.usdPrice ?? 1),
        skip: !activeWallet
    });

    return (
        <TooltipContent px={0} py={1.5} spacing={1}>
            <Column spacing={0.5} px={1.5}>
                <BaseApy {...props} isMaxApy={true} variant="body2" />
                <RewardsMaxLeverage {...props} />
            </Column>
            <Divider />
            {renderDailyPoints(props, principalBorrowedWithLeverageUsd)}
            {renderExternalPointRewards(props)}
        </TooltipContent>
    );
}

function renderDailyPoints(props: RewardsLoopsApyProps, principalBorrowedWithLeverageUsd?: number) {
    if (principalBorrowedWithLeverageUsd) {
        return <RewardsDailyPoints {...props} principalBorrowedWithLeverageUsd={principalBorrowedWithLeverageUsd} />;
    }
    return <RewardsNoRouteFound {...props} />;
}

function renderExternalPointRewards(props: RewardsLoopsApyProps) {
    if (props.externalPointRewards?.length) {
        return (
            <>
                <Divider />
                <RewardsExternalPointsRewards {...props} />
            </>
        );
    }
    return null;
}

function RewardsNoRouteFound(props: RewardsLoopsApyProps) {
    return (
        <Column px={1.5}>
            <RewardsDailyPointsBreakdown {...props} />
        </Column>
    );
}
